const schoolsLogos = {
    alexUni: require('./alex.png'),
    iti: require('./iti.png')
}

module.exports = schoolsLogos;
